<script lang="ts" setup>
import BaseIcon from "@/components/Base/Icon/Icon.vue";
import { type Props as BaseIconProps } from "@/components/Base/Icon/Icon.vue";
import { type BootstrapIconName } from "@/types/bootstrap-icons";

defineOptions({ name: "BaseDropdownItemContent" });

type Props = {
  iconName?: `${BootstrapIconName}`;
  iconSvg?: Component;
  iconColor?: BaseIconProps["color"];
  iconBgColor?: string;
  label?: string;
  withRadio?: boolean;
  withRadioCheck?: boolean;
  checked?: boolean;
};

defineProps<Props>();
</script>

<template>
  <BaseIcon
    v-if="iconName || iconSvg"
    :icon-name="iconName"
    :icon-svg="iconSvg"
    :color="iconColor"
    :bg-color="iconBgColor"
    size="body"
  />
  <span
    v-if="withRadio"
    class="radio-indicator"
    :class="{ checked }"
    aria-hidden="true"
  ></span>
  <span
    v-else-if="withRadioCheck"
    class="radio-check-indicator"
    :class="{ checked }"
    aria-hidden="true"
  >
    <BaseIcon v-if="checked" icon-name="check" color="success" size="body" />
  </span>
  <slot>{{ label }}</slot>
</template>

<style scoped lang="scss">
.radio-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: $font-size-sm;
  height: $font-size-sm;
  border: 1px solid $color-secondary;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: $color-surface-white;
  margin-right: $spacer-2;
  position: relative;
  vertical-align: middle;
  margin-top: -0.2em;

  &.checked {
    border-color: $color-primary;
    background-color: $color-primary;

    &::after {
      content: "";
      position: absolute;
      width: calc($font-size-sm / 2.4);
      height: calc($font-size-sm / 2.4);
      border-radius: 50%;
      background-color: $color-surface-white;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.radio-check-indicator {
  width: $spacer-3;
}
</style>
